import IconButton from '@mui/icons-material';
import { MicOffRounded, Mic } from '@mui/icons-material';
import {
  CCfToggleIconButton,
  CcfScheduleNewCommitmentIcon,
} from '@nice-ccf/ui-controls';
import { CallIcons } from '../ccf-call-conference.slice';

export const callConferenceIcons: CallIcons[] = [
  // {
  //   name: "mic-off-rounded",
  //   component: (
  //     <CCfToggleIconButton
  //       icon={<MicOffRounded />}
  //       toggleIcon={<Mic />}
  //       onClick={() => {
  //         console.log("here");
  //       }}
  //     />
  //   ),
  // },
  // {
  //   name: "event-rounded",
  //   component: (
  //     <IconButton
  //       color="secondary"
  //       children={<CcfScheduleNewCommitmentIcon />}
  //       onClick={() => console.log("event rounded")}
  //     />
  //   ),
  // },
];
